// TODO: change the font styles
export const FontFamily = {
	Poppins_Bold: "Poppins, sans-serif",
	Poppins_SemiBold: "Poppins, sans-serif",
	Poppins_Regular: "Poppins, sans-serif",
	Poppins_Medium: "Poppins, sans-serif",

	Inter_Bold: "Inter, sans-serif",
	Inter_SemiBold: "Inter, sans-serif",
	Inter_Regular: "Inter, sans-serif",
	Inter_Medium: "Inter, sans-serif",
};
